import {
  SET_SIGNERING_STATUS,
  SET_ERROR,
  CLEAR_SIGNERING,
} from "../constants/signering";

const initialState = {
  status: "",
  error: "",
};

export const signering = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIGNERING_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR_SIGNERING:
      return initialState;
    default:
      return state;
  }
};
